import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {CSSTransition, SwitchTransition} from 'react-transition-group';
import {getLocaleDateString} from '../../utils/dateUtils';
import './DateDisplay.less';

const dateDisplayClassName = 'date-display';
const dateDisplayLabelClassName = `${dateDisplayClassName}-label`;
const dateDisplayValueClassName = `${dateDisplayClassName}-value`;
const dateDisplayEmptyClassName = `${dateDisplayClassName}--empty`;
const dateDisplayNotEmptyClassName = `${dateDisplayClassName}--not-empty`;
const dateDisplayActiveClassName = `${dateDisplayClassName}--active`;
const transitionEnterClassName = 'enter';
const transitionEnterActiveClassName = 'enter-active';
const transitionExitClassName = 'exit';
const transitionExitActiveClassName = 'exit-active';
const transitionTimeout = 350;

const DateDisplay = ({locale, label, date, isActive, dateFormatOptions}) => {
    const prevDateRef = useRef(null);

    const className = classNames(dateDisplayClassName, {
        [dateDisplayEmptyClassName]: !date,
        [dateDisplayNotEmptyClassName]: !!date,
        [dateDisplayActiveClassName]: isActive,
    });

    const transitionKey = `date-display-${date}`;
    const transitionMode = date && prevDateRef.current ? 'out-in' : 'in-out';
    const transitionClassNames = {
        enter: classNames(transitionEnterClassName),
        enterActive: classNames(transitionEnterActiveClassName),
        exit: classNames(transitionExitClassName),
        exitActive: classNames(transitionExitActiveClassName),
    };

    const value = getLocaleDateString(date, locale, dateFormatOptions);

    prevDateRef.current = date;

    return (
        <dl className={className}>
            <dt className={dateDisplayLabelClassName}>{label}</dt>
            <dd className={dateDisplayValueClassName}>
                <SwitchTransition mode={transitionMode}>
                    <CSSTransition
                        key={transitionKey}
                        classNames={transitionClassNames}
                        timeout={transitionTimeout}
                    >
                        <span>{value}</span>
                    </CSSTransition>
                </SwitchTransition>
            </dd>
        </dl>
    );
};

DateDisplay.propTypes = {
    locale: PropTypes.string,
    label: PropTypes.string.isRequired,
    date: PropTypes.string,
    dateFormatOptions: PropTypes.objectOf(PropTypes.string),
    isActive: PropTypes.bool,
};

DateDisplay.defaultProps = {
    label: 'Date',
    locale: 'en_US',
    dateFormatOptions: {
        month: 'short',
        day: 'numeric',
        weekday: 'short',
    },
};

export default DateDisplay;
